// import { responseSchema } from './response-schema';
export var makeRequestConfig = function (url) { return ({
    endpoint: "".concat(url, "/config.json"),
    parseType: 'json',
    mode: 'cors',
    cache: 'no-store',
    // todo add schema
    // responseSchema,
    extraValidationCallback: function () { return true; },
    isErrorTextStraightToOutput: true,
    pureJsonFileResponse: true,
    retry: 2,
    notRetryWhenOffline: true,
}); };
